import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

function AdvancedCharting () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative pt-[80px] xl:pt-[160px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
                <div className="flex flex-col-reverse xl:flex-row gap-[20px] xl:gap-[35px]">
                    <div className="flex flex-col xl:flex-row gap-[20px] xl:gap-[35px]">
                        <div>
                            <div className="bg-[#E9E9E9] rounded-[20px] xl:w-[279px] xl:h-[214px] py-[14px] xl:py-0 flex items-center justify-center">
                                <p className="merriweather italic font-[700] text-[14px] xl:text-[20px]">{t('trade.11')}</p>
                            </div>
                            <div className="bg-[#E9E9E9] rounded-[20px] xl:w-[279px] xl:h-[214px] py-[14px] xl:py-0 flex items-center justify-center mt-[20px]">
                                <p className="merriweather italic font-[700] text-[14px] xl:text-[20px]">{t('trade.12')}</p>
                            </div>
                        </div>
                        <div>
                            <div className="bg-[#E9E9E9] rounded-[20px] xl:w-[279px] xl:h-[214px] py-[14px] xl:py-0 flex items-center justify-center">
                                <p className="merriweather italic font-[700] text-[14px] xl:text-[20px]">{t('trade.13')}</p>
                            </div>
                            <div className="bg-[#E9E9E9] rounded-[20px] xl:w-[279px] xl:h-[214px] py-[14px] xl:py-0 flex items-center justify-center mt-[20px]">
                                <p className="merriweather italic font-[700] text-[14px] xl:text-[20px]">{t('trade.14')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-[#353535] w-full rounded-[20px] h-[447px] p-[30px] xl:p-[40px]">
                        <p className="text-[20px] xl:text-[35px] italic font-[700] text-white merriweather"><Trans>{t('trade.15')}</Trans></p>
                        <p className="mt-[30px] inter text-[14px] xl:text-[16px] text-white font-[300] fdfd"><Trans>{t('trade.16')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] text-white font-[300] fdfd"><Trans>{t('trade.17')}</Trans></p>
                        <Button className={"mt-[40px]"}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdvancedCharting;